module.exports = __webpack_public_path__ + "img/tablet-bar.8cb448bc.png";